/**
 * sophior-review-sync.js
 * Houdt de shopreview-claims exact gelijk aan de Webwinkelkeur-widget.
 * Server-side rendert snippets/sophior-review-text.liquid een basiswaarde
 * uit de theme settings; dit script leest de live score en het gebundelde
 * reviewaantal (alle platformen) uit de valued-widget-elementen op de
 * pagina (er kunnen er meerdere zijn, bv. announcement bar + hero) en
 * ververst alle [data-wwk-score]/[data-wwk-count] spans.
 * Laadt geen enkele widget (consent/adblocker), dan blijft de basiswaarde staan.
 *
 * Redesign Het Werkblad (D02 F0-6, D06 §3.8 punt 4; s03-zekerheden, golf 1):
 * alleen met sophior_uitrol_tekstcorrecties aan (body-klasse
 * sophior-uitrol--tekstcorrecties, F0-b) draait de verbeterde versie:
 * - wacht ook op een shadowRoot die pas na de eerste render verschijnt (elke
 *   250 ms, hooguit 60 keer, dus 15 s) en observeert hem dan alsnog
 *   (verbeterronde 27 okt 2026, PLAN §5 s03: was 12 keer, 3 s; de widget
 *   verschijnt 3 tot 8 s na het laden);
 * - werkt ook aria-labels bij: data-wwk-aria="... [score] ... [reviews] ...";
 * - console.warn met beide waarden als de widget afwijkt van de basiswaarde.
 * Zonder die body-klasse draait de huidige versie hieronder, ongewijzigd.
 */
(function () {
  var nieuw = !!(document.body && document.body.classList.contains('sophior-uitrol--tekstcorrecties'));
  if (nieuw) return;

  if (!document.querySelector('[data-wwk-score], [data-wwk-count]')) return;

  var widgets = document.querySelectorAll('valued-widget');
  if (!widgets.length) return;

  var SCORE_PATTERN = /(\d{1,2},\d)\s*\|\s*(\d+)\s*reviews/i;
  var done = false;
  var observer;
  var fallbackTimer;

  function readMatch() {
    for (var i = 0; i < widgets.length; i++) {
      var widget = widgets[i];
      var root = widget.shadowRoot || widget;
      var text = root && root.textContent;
      var match = text && text.match(SCORE_PATTERN);
      if (match) return match;
    }
    return null;
  }

  function applyMatch(match) {
    if (done) return;
    done = true;
    if (observer) observer.disconnect();
    if (fallbackTimer) clearTimeout(fallbackTimer);
    /* Op het update-moment query'en: carousels klonen spans na load */
    document.querySelectorAll('[data-wwk-score]').forEach(function (el) { el.textContent = match[1]; });
    document.querySelectorAll('[data-wwk-count]').forEach(function (el) { el.textContent = match[2]; });
  }

  function tryNow() {
    var match = readMatch();
    if (match) applyMatch(match);
    return !!match;
  }

  if (tryNow()) return;

  observer = new MutationObserver(function () {
    tryNow();
  });
  widgets.forEach(function (widget) {
    var root = widget.shadowRoot || widget;
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  });

  /* Fallback: shadowRoot verschijnt soms pas na de eerste render-cyclus */
  fallbackTimer = setTimeout(function () {
    if (done) return;
    /* shadowRoot kan er nu wel zijn terwijl de observer eerder niets had om te observeren */
    widgets.forEach(function (widget) {
      var root = widget.shadowRoot || widget;
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    });
    if (!tryNow()) {
      observer.disconnect();
      console.warn('sophior-review-sync: Webwinkelkeur-widgettekst niet herkend; fallback-reviewscore uit theme settings blijft staan.');
    }
  }, 10000);
})();

/* Verbeterde versie, alleen met sophior_uitrol_tekstcorrecties aan (zie boven). */
(function () {
  if (!(document.body && document.body.classList.contains('sophior-uitrol--tekstcorrecties'))) return;

  if (!document.querySelector('[data-wwk-score], [data-wwk-count], [data-wwk-aria]')) return;

  var widgets = document.querySelectorAll('valued-widget');
  if (!widgets.length) return;

  var SCORE_PATTERN = /(\d{1,2},\d)\s*\|\s*(\d+)\s*reviews/i;
  var POLL_MS = 250;
  var POLL_MAX = 60; /* 15 s (verbeterronde 27 okt 2026; was 12) */
  var done = false;
  var observer;
  var fallbackTimer;
  var pollTimer;
  var observed = [];

  function readMatch() {
    for (var i = 0; i < widgets.length; i++) {
      var widget = widgets[i];
      var root = widget.shadowRoot || widget;
      var text = root && root.textContent;
      var match = text && text.match(SCORE_PATTERN);
      if (match) return match;
    }
    return null;
  }

  function firstText(selector) {
    var el = document.querySelector(selector);
    return el ? el.textContent.trim() : '';
  }

  function applyMatch(match) {
    if (done) return;
    done = true;
    if (observer) observer.disconnect();
    if (fallbackTimer) clearTimeout(fallbackTimer);
    if (pollTimer) clearInterval(pollTimer);

    var oldScore = firstText('[data-wwk-score]');
    var oldCount = firstText('[data-wwk-count]');
    if ((oldScore && oldScore !== match[1]) || (oldCount && oldCount !== match[2])) {
      console.warn('sophior-review-sync: widget wijkt af van de basiswaarde. Basis: ' +
        oldScore + ' | ' + oldCount + ', widget: ' + match[1] + ' | ' + match[2] +
        '. Werk het shopmetafield sophior.wwk_score/wwk_count (of wwk_score/wwk_count) bij.');
    }

    /* Op het update-moment query'en: carousels klonen spans na load */
    document.querySelectorAll('[data-wwk-score]').forEach(function (el) { el.textContent = match[1]; });
    document.querySelectorAll('[data-wwk-count]').forEach(function (el) { el.textContent = match[2]; });
    document.querySelectorAll('[data-wwk-aria]').forEach(function (el) {
      var tpl = el.getAttribute('data-wwk-aria') || '';
      el.setAttribute('aria-label', tpl.replace(/\[score\]/g, match[1]).replace(/\[reviews\]/g, match[2]));
    });
  }

  function tryNow() {
    var match = readMatch();
    if (match) applyMatch(match);
    return !!match;
  }

  function observe(root) {
    if (observed.indexOf(root) !== -1) return;
    observed.push(root);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (tryNow()) return;

  observer = new MutationObserver(function () {
    tryNow();
  });
  widgets.forEach(function (widget) {
    observe(widget.shadowRoot || widget);
  });

  /* Wacht op een shadowRoot die later wordt aangemaakt (open shadow DOM) */
  var polls = 0;
  pollTimer = setInterval(function () {
    polls += 1;
    widgets.forEach(function (widget) {
      if (widget.shadowRoot) observe(widget.shadowRoot);
    });
    if (tryNow() || polls >= POLL_MAX) clearInterval(pollTimer);
  }, POLL_MS);

  /* Fallback: na 10 s nog één poging, daarna stoppen */
  fallbackTimer = setTimeout(function () {
    if (done) return;
    widgets.forEach(function (widget) {
      if (widget.shadowRoot) observe(widget.shadowRoot);
    });
    if (!tryNow()) {
      observer.disconnect();
      console.warn('sophior-review-sync: Webwinkelkeur-widgettekst niet herkend; fallback-reviewscore uit theme settings blijft staan.');
    }
  }, 10000);
})();
